var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{attrs:{"disabled":_vm.statusSeatsNumbers.length === 0,"type":"button"},on:{"click":function($event){return _vm.$emit('submit')}}},[_vm._v(" booked now ")])])}
var staticRenderFns = []

export { render, staticRenderFns }